import { render, staticRenderFns } from "./GuaranteeContentTab.vue?vue&type=template&id=4270123b&scoped=true"
import script from "./GuaranteeContentTab.vue?vue&type=script&lang=js"
export * from "./GuaranteeContentTab.vue?vue&type=script&lang=js"
import style0 from "./GuaranteeContentTab.vue?vue&type=style&index=0&id=4270123b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270123b",
  null
  
)

export default component.exports